<div class="w-full">
  <p-treeSelect
    appendTo="body"
    class="w-full"
    [showClear]="true"
    [options]="categories"
    [showClear]="true"
    selectionMode="single"
    [(ngModel)]="selectedCategory" 
    placeholder="{{ 'global.selectItem' | translate }}"
  >
    <ng-template let-node pTemplate="default">
      <div>
        <span>{{ node?.categoryLabelLoc }}</span>
      </div>
    </ng-template>
    <ng-template let-node pTemplate="value">
      <div>
        <span>{{ node?.categoryBreadcrumbLoc }}</span>
      </div>
    </ng-template>
  </p-treeSelect>
</div>
<div class="footer-buttons">
  <div class="flex">
    <button
      pButton
      type="button"
      label="{{ 'buttons.validate' | translate }}"
      icon="pi pi-check-circle"
      (click)="updateAttributeTypology()"
      [disabled]="showSpinner || !selectedCategory"
      class="mr-2"
    ></button>
  </div>
</div>
@if (showSpinner) {
  <div class="flex justify-content-center mt-5">
    <p-progressSpinner
      styleClass="w-4rem h-4rem"
      strokeWidth="8"
      animationDuration=".5s"
    />
  </div>
}
